/**
 *
 *  AdminSkudForm14852
 *
 */

import React from 'react';
import {AdminSkudForm} from "pages/Requests/AdminSkud";
import {ON_PASS_BLOCKING, ON_PASS_MAKING} from "domain/Data/RequestType/constants";

export class AdminSkudForm14852 extends AdminSkudForm {

    getFields() {
        const fields = super.getFields();

        const typeIndex = fields.findIndex((field) => field.name === 'type');
        fields[typeIndex].visible = true
        fields[typeIndex].type = 'select'
        fields[typeIndex].entityName = 'requestTypes'
        fields[typeIndex].label = 'Вид'
        fields[typeIndex].visibleOptions = [ON_PASS_MAKING, ON_PASS_BLOCKING]

        const visitorFullNameIndex = fields.findIndex((field) => field.name === 'visitorFullName')
        fields[visitorFullNameIndex].label = 'Фамилия Имя'
        fields[visitorFullNameIndex].helperText = 'Фамилия Имя сотрудника'

        const companyNameIndex = fields.findIndex((field) => field.name === 'companyName')
        fields.splice(companyNameIndex, 1)

        const isOffsetCardIndex = fields.findIndex((field) => field.name === 'isOffsetCard')
        fields.splice(isOffsetCardIndex, 1)


        const issueReasonIndex = fields.findIndex((field) => field.name === 'issueReason')
        fields[issueReasonIndex].visible = (values) => values.type === ON_PASS_MAKING

        const departmentIndex = fields.findIndex((field) => field.name === 'department')
        fields[departmentIndex].visibleOptions = null

        return fields;
    }

}

export default AdminSkudForm14852;
